import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9uxjeigntn: FaireBrandEntity = {
  token: "b_9uxjeigntn",
  type: "brand",
  name: "Able",
  avatarUrl:
    "https://cdn.faire.com/fastly/76975c47db1808142f63806c6076ecd6186bd4c74f43b93391fbddf2a5263a8c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e47255c5832e5132aef42548ca3f4be170686260b020a3f45a6838a6ff1578c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/76975c47db1808142f63806c6076ecd6186bd4c74f43b93391fbddf2a5263a8c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e47255c5832e5132aef42548ca3f4be170686260b020a3f45a6838a6ff1578c.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 63,
  isInsider: true,
  description:
    "Able offers contemporary fashion pieces, blending modern trends with timeless elegance for the fashion-forward women seeking refined pieces for every occasion.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:43.787Z",
    importedBy: "entity-db-cli",
  },
};
